import type { FlatConfig } from './flatConfig';

export interface QuoteMetadata {
  preparedFor: string;
  partnerName: string;
  quoteDescription: string;
  notes: string;
  opportunityID: string;
  customerID: string;
  customerNumber: string;
  offerNumber: string;
  configuratorQuoteSerial: string;
  salesforceQuoteNumber: string;
  accountExecutive: string;
  accountExecutiveEmail: string;
  warrantyStartDate: string;
  quoteExpirationDate: string;
}

export function quoteMetadataFromFlat(c: FlatConfig): QuoteMetadata {
  return {
    preparedFor: c.preparedFor,
    partnerName: c.partnerName,
    quoteDescription: c.quoteDescription,
    notes: c.notes,
    opportunityID: c.opportunityID,
    customerID: c.customerID,
    customerNumber: c.customerNumber,
    offerNumber: c.offerNumber,
    configuratorQuoteSerial: c.configuratorQuoteSerial,
    salesforceQuoteNumber: c.salesforceQuoteNumber,
    accountExecutive: c.accountExecutive,
    accountExecutiveEmail: c.accountExecutiveEmail,
    warrantyStartDate: c.warrantyStartDate,
    quoteExpirationDate: c.quoteExpirationDate,
  };
}

export function quoteMetadataToFlat(m: QuoteMetadata): Pick<FlatConfig, keyof QuoteMetadata> {
  return { ...m };
}
